import React from 'react';
import { Dropdown } from '../dropdown';

const towns = [
  {value: 'krakow_1616172264', label: 'Kraków'},
  {value: 'warszawa_1616024847', label: 'Warszawa'},
  {value: 'katowice_1616798495', label: 'Katowice'},
  {value: 'sosnowiec_1616057255', label: 'Sosnowiec'},
  {value: 'dabrowa gornicza_1616312023', label: 'Dąbrowa Górnicza'},
  {value: 'tychy_1616396493', label: 'Tychy'},
  {value: 'gliwice_1616311376', label: 'Gliwice'},
  {value: 'pszczyna_1616839287', label: 'Pszczyna'},
  {value: 'myslenice_1616135502', label: 'Myślenice'},
];


export const DropdownTown = ({ onBlur, value, onChange, name, id}) => {
  return (
    <Dropdown name={name} id={id} label='Miasto'
              defaultValue={towns.find(e => value?.slug ? e.value === value?.slug : value)}
              onBlur={onBlur}
              onChange={e => onChange(e.value)}
              options={towns}/>
  );
};
